import { RHFNumberField } from '@components/forms/hook-form';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { NumberFormatValues } from 'react-number-format';
import { ChoicesOrderUnitMeasure } from '../../../orders/types';
import { getAmountDecorator } from '../../utils/amount-input.utils';
import {
  TotalMustBeBilled,
  SecondStepFormItem,
} from '../form/billing-order-new-edit-secondstep-form';

interface DistributionValueInputProps {
  formValueIndex: number;
  itemIndex: number;
  item: SecondStepFormItem;
}
export const DistributionValueInput = ({
  itemIndex,
  item,
  formValueIndex,
}: DistributionValueInputProps) => {
  const { t } = useTranslation();
  const { setValue, getValues } = useFormContext();

  const amountDecorator = getAmountDecorator(item.unitMeasure);

  const valueFieldName = `formValues[${formValueIndex}].items[${itemIndex}].value`;
  const amountFieldName = `formValues[${formValueIndex}].items[${itemIndex}].amount`;

  const totalMustBeBilled: TotalMustBeBilled[] = getValues('totalMustBeBilled');

  const handleChange = (inputValue: NumberFormatValues) => {
    const value = Number(inputValue.value);
    setValue(valueFieldName, value);

    let amount = 0;
    switch (item.unitMeasure) {
      case ChoicesOrderUnitMeasure.amount: {
        amount = value;
        break;
      }
      case ChoicesOrderUnitMeasure.quantity: {
        amount = value * item.quantity;
        break;
      }
      case ChoicesOrderUnitMeasure.percentageAmount: {
        const itemId = `${item.itemInfo.subscription}-${item.itemInfo.type}`;
        const itemTotal = totalMustBeBilled.find((a) => a.itemId === itemId);
        if (!itemTotal) {
          return;
        }
        amount = (value / 100) * itemTotal.total;
      }
    }
    setValue(amountFieldName, amount);
  };

  return (
    <RHFNumberField
      onValueChange={handleChange}
      thousandsGroupStyle="thousand"
      name={valueFieldName}
      inputProps={{ autoComplete: 'off' }}
      allowNegative={false}
      thousandSeparator
      decimalScale={amountDecorator.decimalScale}
      label={t('Value to be billed')}
      size="small"
      suffix={amountDecorator.suffix}
      prefix={amountDecorator.prefix}
      sx={{ width: '60%' }}
    />
  );
};
